import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../toast/successToast";
import errorToast from "../../toast/errorToast";
import FormTextField from "../../form/text";
import { FormDropDown } from "../../form/dropdown";
import { FormTextAreaField } from "../../form/text-area";
import { useEffect, useState } from "react";
import { FormMultiFileUploadField } from "../../form/multi-file";
import { FormDateField, FormTimeField } from "../../form/date";
import { api } from "../../../redux/apis/api";

const CustomerActivityCreateModal = ({
  isOpen = false,
  onClose = () => {},
  listFnc = () => {},
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const params = useParams();
  const [userList, setuserList] = useState([]);
  const [customerList, setCustomerList] = useState([]);

  const initialValues = {
    customer_id: params?.id,
    title: "",
    description: "",
    file: [],
    type: "",
    status: "",
    activity_date: "",
    activity_time: "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/customer/activity/create`, values)
      .then((response) => {
        successToast(response.message);
        onClose();
        console.log(response, "response");
        listFnc();
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchUserDropDownData = () => {
    api
      .get(`/ffadmin/user-list-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.users?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setuserList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchLeadsDropDownData = () => {
    api
      .get(`/customer/dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.customers?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCustomerList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchUserDropDownData();
    fetchLeadsDropDownData();
  }, []);

  const TypeOptions = [
    { label: "call", value: "call" },
    { label: "sms", value: "sms" },
    { label: "quotation", value: "quotation" },
    { label: "visit", value: "visit" },
    { label: "meeting", value: "meeting" },
    { label: "complain resolution", value: "complain_resolution" },
    { label: "payment collection", value: "payment_collection" },
    { label: "delivery visit", value: "delivery_visit" },
    { label: "order visit", value: "order_visit" },
    { label: "sales visit", value: "sales_visit" },
    { label: "cheque deposit", value: "cheque_deposit" },
    { label: "follow up", value: "follow_up" },
  ];

  const statusOptions = [
    { label: "cancelled", value: "cancelled" },
    { label: "confirmed", value: "confirmed" },
    { label: "completed", value: "completed" },
  ];

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-[50rem] w-full md:p-8 p-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              <Form>
                <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                  <h2 className="text-xl font-semibold capitalize">
                    customer activity - Create
                  </h2>
                  <div className="flex gap-3 items-center">
                    <button
                      onClick={() => onClose()}
                      type="button"
                      className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                    >
                      Create
                    </button>
                  </div>
                </div>
                <section className="overflow-auto w-full h-[60vh]">
                  <section className="w-full max-w-[40rem]">
                    <div className="my-4">
                      <FormTextField
                        name={"title"}
                        label={"title"}
                        placeholder={`Enter title`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextAreaField
                        name={"description"}
                        label={"description"}
                        placeholder={`Enter description`}
                        rows={3}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name={"type"}
                        label={"type"}
                        options={TypeOptions}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name={"status"}
                        label={"status"}
                        options={statusOptions}
                      />
                    </div>
                    <div className="my-4">
                      <FormMultiFileUploadField
                        name={"file"}
                        label={"file"}
                        accept=".pdf,.doc,.docx,.jpg,.png"
                      />
                    </div>
                    <div className="my-4">
                      <FormDateField
                        name={"activity_date"}
                        label={"activity date"}
                      />
                    </div>
                    <div className="my-4">
                      <FormTimeField
                        name={"activity_time"}
                        label={"activity time"}
                      />
                    </div>
                  </section>
                </section>
              </Form>
            </Formik>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerActivityCreateModal;
